import React, { useEffect, useState } from 'react';
import { Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import { Sidebar as ProSidebar } from 'react-pro-sidebar';
import './Sidebar.scss'; 
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import logo from "../../assets/img/HE-LogoB-200.png";
import halfLogo from "../../assets/img/HE-half-LogoB-200.png";
import useMediaQuery from '../../hooks/useMediaQuery';
import {ROLES} from '../../model/roles';
import { setSidebarCollapse } from '../../store/actions/sidebarCollapse';

const Sidebar = () => {
  const navigate = useNavigate(); 
  const location = useLocation();
  const [currentRoute, setCurrentRoute] = useState(location.pathname);
  const isAddContenuti = location.pathname === "/aggiungi-contenuti" || location.pathname === "/checkout";
  const userLoggedIn = useSelector(state => state.user?.userData);
  const isWideScreen = useMediaQuery('(min-width: 1200px)');
  const isMax600px = useMediaQuery('(max-width: 600px)');
  const collapsedState = useSelector(state => state?.sidebarCollapse);
  const dispatch = useDispatch();


 
  useEffect(() => {
    if(!isWideScreen) {
      dispatch(setSidebarCollapse((true)));
    }
  }, [isWideScreen])
/*
  useEffect(() => {
    // Questa logica imposta lo stato della sidebar in base alla larghezza dello schermo.
    // Se lo schermo NON è largo, la sidebar deve essere chiusa (true).
    // Se lo schermo È largo, la sidebar deve essere aperta (false).
    dispatch(setSidebarCollapse(!isWideScreen));
  }, [isWideScreen, dispatch]); // Aggiungiamo dispatch alle dipendenze per coerenza
  */
  useEffect(() => {
    setCurrentRoute(location.pathname)
    if(isAddContenuti) {
      dispatch(setSidebarCollapse((true)));
    }
  }, [location.pathname])

  const toggleMenu = () => {
      dispatch(setSidebarCollapse(!collapsedState));
  }

  // --- CORREZIONE: Unificata la logica di navigazione e chiusura del menu ---
  const handleNavigation = (path) => {
    navigate(path);
    // Se lo schermo è piccolo, chiudi la sidebar dopo aver navigato
    if (isMax600px) {
      dispatch(setSidebarCollapse(true));
    }
  };

  return (
    <ProSidebar collapsed={collapsedState} className="custom-sidebar">

        {
          !collapsedState && (
            <div onClick={toggleMenu} className={`${!collapsedState && isMax600px ? "d-flex justify-content-between p-3" : "text-end py-3 me-3"}`}>
                 {isMax600px && (
                    <img
                      role='button'
                      onClick={() => navigate("/corsi")}
                      src={logo}
                      alt="logo"
                    />
                )}
                  <i className={`bi bi-x-lg fs-5`} role='button'></i>
                  </div>
                )
         }
      <Menu iconShape="square" className="menu-dark small" closeOnClick={true}>
         {
          collapsedState && (
            <div className={`${(collapsedState) && "py-3 text-center" }`}>
            <i className="bi bi-list fs-5" role='button' onClick={toggleMenu}></i>
            </div>
          )
         }
          <MenuItem icon={<i className="bi bi-house"></i>} onClick={() => handleNavigation("/corsi")}>Home</MenuItem>
        {
           (userLoggedIn?.role === ROLES.ADMIN || userLoggedIn?.role === ROLES.DEVELOPER || userLoggedIn?.role === ROLES.COURSE_DESIGNER ||userLoggedIn?.role === ROLES.DOCENTE || userLoggedIn?.role === ROLES.PARTNER) && (
              <>
              <SubMenu icon={<i className={`bi bi-mortarboard ${(currentRoute === "/gestione-corsi" || currentRoute === "/assegna-corsi" || currentRoute === "/aggiungi-contenuti") ? "text-primary" : "text-light"}`}></i>} label="Corsi" title="Corsi"> 
                {
                  (userLoggedIn?.role === ROLES.ADMIN  || userLoggedIn?.role === ROLES.DEVELOPER || userLoggedIn?.role === ROLES.COURSE_DESIGNER || userLoggedIn?.role === ROLES.DOCENTE || userLoggedIn?.role === ROLES.PARTNER) && (
                    <MenuItem icon={<i className={`bi bi-circle-fill ${currentRoute === "/gestione-corsi" ? "text-primary" : "text-light"} menu-icon`}></i>} onClick={() => handleNavigation("/gestione-corsi")}>Gestione corsi</MenuItem>
                  )
                }
              </SubMenu>      
              </>
            )
          }

          {
           (userLoggedIn?.role === ROLES.CORSISTA) && (
              <>
              <SubMenu icon={<i className={`bi bi-mortarboard ${currentRoute === "/area-personale/corsi" ? "text-primary" : "text-light"}`}></i>} label="Corsi" title="Corsi"> 
                <MenuItem icon={<i className={`bi bi-circle-fill ${currentRoute === "/area-personale/corsi" ? "text-primary" : "text-light"} menu-icon`}></i>} onClick={() => handleNavigation("/area-personale/corsi")}>I miei corsi</MenuItem>
              </SubMenu>      
              </>
            )
          }

        {
        (userLoggedIn?.role === ROLES.ADMIN || userLoggedIn?.role === ROLES.DEVELOPER || userLoggedIn?.role === ROLES.COURSE_DESIGNER || userLoggedIn?.role === ROLES.DOCENTE) && (
          <SubMenu icon={<i className={`bi bi-person-workspace ${currentRoute === "/gestione-classi" ? "text-primary" : "text-light"}`}></i>} label="Classi" title="Classi"> 
            <MenuItem icon={<i className={`bi bi-circle-fill ${currentRoute === "/gestione-classi" ? "text-primary" : "text-light"} menu-icon`}></i>} onClick={() => handleNavigation("/gestione-classi")}>Gestione classi</MenuItem>
          </SubMenu>  
        )
        }
        
        {
           (userLoggedIn?.role === ROLES.TUTOR) && (
              <>
          <SubMenu icon={<i className={`bi bi-person-workspace ${currentRoute === "/area-personale/classi" ? "text-primary" : "text-light"}`}></i>} label="Classi" title="Classi"> 
            <MenuItem icon={<i className={`bi bi-circle-fill ${currentRoute === "/area-personale/classi" ? "text-primary" : "text-light"} menu-icon`}></i>} onClick={() => handleNavigation("/area-personale/classi")}>Le mie classi</MenuItem>
          </SubMenu>    
              </>
            )
        }
        {(userLoggedIn?.role === ROLES.SUPERPARTNER) && (
            <SubMenu 
                icon={<i className={`bi bi-shop-window ${currentRoute.startsWith("/vetrina-corsi") ? "text-primary" : "text-light"}`}></i>} 
                label="Vetrina" 
                title="Vetrina"
            >
                <MenuItem 
                    icon={<i className={`bi bi-circle-fill ${currentRoute === "/vetrina-corsi" ? "text-primary" : "text-light"} menu-icon`}></i>} 
                    onClick={() => handleNavigation("/vetrina-corsi")}
                >
                    Vetrina Corsi
                </MenuItem>
            </SubMenu>
        )}
        {
          (userLoggedIn?.role === ROLES.ADMIN ||  userLoggedIn?.role === ROLES.DEVELOPER) && (
            <SubMenu icon={<i className={`bi bi-star-fill ${currentRoute === "/gestione-superpartner" ? "text-primary" : "text-light"}`}></i>} label="Superpartner" title="Superpartner"> 
              <MenuItem icon={<i className={`bi bi-circle-fill ${currentRoute === "/gestione-superpartner" ? "text-primary" : "text-light"} menu-icon`}></i>} onClick={() => handleNavigation("/gestione-superpartner")}>Gestione Superpartner</MenuItem>
              <MenuItem icon={<i className={`bi bi-circle-fill ${currentRoute === "/dashboard-rendicontazione-superpartner" ? "text-primary" : "text-light"} menu-icon`}></i>} onClick={() => handleNavigation("/dashboard-rendicontazione-superpartner")}>Dashboard Rend. Superpartner</MenuItem>
              <MenuItem icon={<i className={`bi bi-circle-fill ${currentRoute === "/archivio-rendicontazioni-superpartner" ? "text-primary" : "text-light"} menu-icon`}></i>} onClick={() => handleNavigation("/archivio-rendicontazioni-superpartner")}>Archivio Liquidazioni SP</MenuItem>
            </SubMenu>   
          )
        }
        {
          (userLoggedIn?.role === ROLES.ADMIN ||  userLoggedIn?.role === ROLES.DEVELOPER || userLoggedIn?.role === ROLES.COURSE_DESIGNER || userLoggedIn?.role === ROLES.SUPERPARTNER) && (
          <SubMenu icon={<i className={`bi bi-building ${currentRoute.startsWith("/gestione-agenzie") || currentRoute.startsWith("/dashboard-rendicontazione") ? "text-primary" : "text-light"}`}></i>} label="Agenzie" title="Agenzie">

            {/* Visibile a tutti (Admin e Superpartner) */}
            <MenuItem icon={<i className={`bi bi-circle-fill ${currentRoute === "/gestione-agenzie" ? "text-primary" : "text-light"} menu-icon`}></i>} onClick={() => handleNavigation("/gestione-agenzie")}>Gestione Agenzie</MenuItem>

            {/* Visibile SOLO se NON sei un Superpartner (quindi Admin, Dev, ecc.) */}
            {userLoggedIn.role !== ROLES.SUPERPARTNER && (
              <>
                <MenuItem icon={<i className={`bi bi-circle-fill ${currentRoute === "/dashboard-rendicontazione-admin" ? "text-primary" : "text-light"} menu-icon`}></i>} onClick={() => handleNavigation("/dashboard-rendicontazione-admin")}>Dashboard Rendicontazione</MenuItem>
                <MenuItem icon={<i className={`bi bi-circle-fill ${currentRoute === "/archivio-rendicontazioni" ? "text-primary" : "text-light"} menu-icon`}></i>} onClick={() => handleNavigation("/archivio-rendicontazioni")}>Archivio Liquidazioni</MenuItem>
              </>
            )}
          </SubMenu>
          )
        }  

        {
          (userLoggedIn?.role === ROLES.ADMIN ||  userLoggedIn?.role === ROLES.DEVELOPER || userLoggedIn?.role === ROLES.COURSE_DESIGNER || userLoggedIn?.role === ROLES.PARTNER || userLoggedIn?.role === ROLES.SUPERPARTNER) && (
            <SubMenu icon={<i className={`bi bi-people-fill ${(currentRoute === "/gestione-utenti" || currentRoute === "/blacklist-utenti") ? "text-primary" : "text-light"}`}></i>} label="Utenti" title="Utenti"> 
              <MenuItem icon={<i className={`bi bi-circle-fill ${currentRoute === "/gestione-utenti" ? "text-primary" : "text-light"} menu-icon`}></i>} onClick={() => handleNavigation("/gestione-utenti")}>Gestione utenti</MenuItem>
              {(userLoggedIn?.role === ROLES.ADMIN ||  userLoggedIn?.role === ROLES.DEVELOPER) && (
                <MenuItem icon={<i className={`bi bi-circle-fill ${currentRoute === "/blacklist-utenti" ? "text-primary" : "text-light"} menu-icon`}></i>} onClick={() => handleNavigation("/blacklist-utenti")}>Blacklist utenti</MenuItem>
              )}
            </SubMenu>   
          ) 
        }
       
        {
        (userLoggedIn?.role === ROLES.ADMIN ||  userLoggedIn?.role === ROLES.DEVELOPER || userLoggedIn?.role === ROLES.COURSE_DESIGNER) && (
          <SubMenu icon={<i className={`bi bi-buildings ${currentRoute === "/gestione-sedi" ? "text-primary" : "text-light"}`}></i>} label="Sedi" title="Sedi"> 
            <MenuItem icon={<i className={`bi bi-circle-fill ${currentRoute === "/gestione-sedi" ? "text-primary" : "text-light"} menu-icon`}></i>} onClick={() => handleNavigation("/gestione-sedi")}>Gestione sedi </MenuItem>
          </SubMenu>   
          )
        }
        {
        (userLoggedIn?.role === ROLES.ADMIN ||  userLoggedIn?.role === ROLES.DEVELOPER || userLoggedIn?.role === ROLES.COURSE_DESIGNER) && (
          <SubMenu icon={<i className={`bi bi-award ${currentRoute === "/gestione-certificazioni" ? "text-primary" : "text-light"}`}></i>} label="Certificazioni" title="Certificazioni"> 
            <MenuItem icon={<i className={`bi bi-circle-fill ${currentRoute === "/gestione-certificazioni" ? "text-primary" : "text-light"} menu-icon`}></i>} onClick={() => handleNavigation("/gestione-certificazioni")}>Gestione Certificazioni </MenuItem>
          </SubMenu>   
          )
        }
       
        {
        (userLoggedIn?.role === ROLES.ADMIN ||  userLoggedIn?.role === ROLES.DEVELOPER || userLoggedIn?.role === ROLES.COURSE_DESIGNER || userLoggedIn?.role === ROLES.DOCENTE || userLoggedIn?.role === ROLES.TUTOR || userLoggedIn?.role === ROLES.CORSISTA) && (
          <SubMenu icon={<i className={`bi bi-ticket-detailed ${currentRoute === "/gestione-ticket" ? "text-primary" : "text-light"}`}></i>} label="Ticket" title="Ticket"> 
          {
            (userLoggedIn?.role === ROLES.CORSISTA) ? ( 
              <MenuItem icon={<i className={`bi bi-circle-fill ${currentRoute === "/area-personale/ticket" ? "text-primary" : "text-light"} menu-icon`}></i>} onClick={() => handleNavigation("/area-personale/ticket")}>I miei ticket</MenuItem>
            ) : (
              <MenuItem icon={<i className={`bi bi-circle-fill ${currentRoute === "/gestione-ticket" ? "text-primary" : "text-light"} menu-icon`}></i>} onClick={() => handleNavigation("/gestione-ticket")}>Gestione ticket </MenuItem>
            )
          }
          </SubMenu>   
          )
        }

        {
        (userLoggedIn?.role === ROLES.CORSISTA || userLoggedIn?.role === ROLES.DEVELOPER) && (
            <MenuItem icon={<i className={`bi bi-person-fill ${currentRoute === "/area-personale/invita-amico" ? "text-primary" : "text-light"}`}></i>} onClick={() => handleNavigation("/area-personale/invita-amico")}>Invita amico</MenuItem>
          )
        }
        {(userLoggedIn?.role === ROLES.PARTNER || userLoggedIn?.role === ROLES.SUPERPARTNER) && (
            <MenuItem icon={<i className="bi bi-graph-up-arrow"></i>} onClick={() => navigate("/rendicontazione")}>Rendicontazione</MenuItem> 
        )}

      
      </Menu>
      {!isMax600px && (
      <div className={`${(isWideScreen && !collapsedState) ? 'px-3' : 'px-4'} py-4 sidebar-logo-container`}>
        <img
          role='button'
          onClick={() => navigate("/corsi")}
          src={(!collapsedState) ? logo : halfLogo}
          alt="logo"
          className="sidebar-logo" 
        />
        {!collapsedState && process.env.REACT_APP_VERSION && (
          <div className="sidebar-logo text-center  mt-2" style={{ position: 'absolute', top: '2%', fontSize: '0.8rem', marginLeft: '15px', color: 'white' }}>
            Versione: {process.env.REACT_APP_VERSION}
          </div>
        )}       
      </div>
      )}
    </ProSidebar>
  );
}

export default Sidebar;
